const TITLE_TAKEN = 'has already been taken';

/** Переводит ответ API конструктора уроков в текст для тоста */
export const getLessonErrorMessage = (error, fallback) => {
  const { status, data } = error?.response ?? {};

  if (status === 401) return 'Войдите в аккаунт, чтобы продолжить';
  if (status === 403) return 'Конструктор уроков доступен только учителям';

  if (status === 422) {
    if (data?.errors?.title) {
      return data.message?.includes(TITLE_TAKEN)
        ? 'Урок с таким названием уже есть'
        : 'Проверьте название урока';
    }

    return 'Часть материалов недоступна, урок не сохранён';
  }

  return fallback;
};
